import * as Types from '../../../../__generated__/base.gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type WholeSyncableNotificationBellStateFragment = { readonly __typename?: 'NotificationBellState', readonly id: string, readonly userId: string, readonly lastBellOpenedAt?: string | null, readonly lastMarkAllReadAt?: string | null, readonly meta: { readonly __typename?: 'SyncableMeta', readonly createdAt: string, readonly createdByUserId: string, readonly updatedAt: string, readonly updatedByUserId: string, readonly deleted: boolean } };

export type SyncNotificationBellStatePullQueryVariables = Types.Exact<{
  input: Types.PullNotificationBellStateInput;
}>;


export type SyncNotificationBellStatePullQuery = { readonly __typename?: 'Query', readonly pullNotificationBellState: { readonly __typename?: 'PullNotificationBellStateResponse', readonly documents: ReadonlyArray<{ readonly __typename?: 'NotificationBellState', readonly id: string, readonly userId: string, readonly lastBellOpenedAt?: string | null, readonly lastMarkAllReadAt?: string | null, readonly meta: { readonly __typename?: 'SyncableMeta', readonly createdAt: string, readonly createdByUserId: string, readonly updatedAt: string, readonly updatedByUserId: string, readonly deleted: boolean } }> } };

export type SyncNotificationBellStatePushMutationVariables = Types.Exact<{
  input: Types.PushNotificationBellStateInput;
}>;


export type SyncNotificationBellStatePushMutation = { readonly __typename?: 'Mutation', readonly pushNotificationBellState: { readonly __typename?: 'PushNotificationBellStateResponse', readonly rows: ReadonlyArray<{ readonly __typename?: 'NotificationBellState', readonly id: string, readonly userId: string, readonly lastBellOpenedAt?: string | null, readonly lastMarkAllReadAt?: string | null, readonly meta: { readonly __typename?: 'SyncableMeta', readonly createdAt: string, readonly createdByUserId: string, readonly updatedAt: string, readonly updatedByUserId: string, readonly deleted: boolean } }> } };

export const WholeSyncableNotificationBellStateFragmentDoc = gql`
    fragment WholeSyncableNotificationBellState on NotificationBellState {
  id
  userId
  lastBellOpenedAt
  lastMarkAllReadAt
  meta {
    createdAt
    createdByUserId
    updatedAt
    updatedByUserId
    deleted
  }
}
    `;
export const SyncNotificationBellStatePullDocument = gql`
    query SyncNotificationBellStatePull($input: PullNotificationBellStateInput!) {
  pullNotificationBellState(input: $input) {
    documents {
      ...WholeSyncableNotificationBellState
    }
  }
}
    ${WholeSyncableNotificationBellStateFragmentDoc}`;

/**
 * __useSyncNotificationBellStatePullQuery__
 *
 * To run a query within a React component, call `useSyncNotificationBellStatePullQuery` and pass it any options that fit your needs.
 * When your component renders, `useSyncNotificationBellStatePullQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSyncNotificationBellStatePullQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSyncNotificationBellStatePullQuery(baseOptions: Apollo.QueryHookOptions<SyncNotificationBellStatePullQuery, SyncNotificationBellStatePullQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SyncNotificationBellStatePullQuery, SyncNotificationBellStatePullQueryVariables>(SyncNotificationBellStatePullDocument, options);
      }
export function useSyncNotificationBellStatePullLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SyncNotificationBellStatePullQuery, SyncNotificationBellStatePullQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SyncNotificationBellStatePullQuery, SyncNotificationBellStatePullQueryVariables>(SyncNotificationBellStatePullDocument, options);
        }
export type SyncNotificationBellStatePullQueryHookResult = ReturnType<typeof useSyncNotificationBellStatePullQuery>;
export type SyncNotificationBellStatePullLazyQueryHookResult = ReturnType<typeof useSyncNotificationBellStatePullLazyQuery>;
export type SyncNotificationBellStatePullQueryResult = Apollo.QueryResult<SyncNotificationBellStatePullQuery, SyncNotificationBellStatePullQueryVariables>;
export const SyncNotificationBellStatePushDocument = gql`
    mutation SyncNotificationBellStatePush($input: PushNotificationBellStateInput!) {
  pushNotificationBellState(input: $input) {
    rows {
      ...WholeSyncableNotificationBellState
    }
  }
}
    ${WholeSyncableNotificationBellStateFragmentDoc}`;
export type SyncNotificationBellStatePushMutationFn = Apollo.MutationFunction<SyncNotificationBellStatePushMutation, SyncNotificationBellStatePushMutationVariables>;

/**
 * __useSyncNotificationBellStatePushMutation__
 *
 * To run a mutation, you first call `useSyncNotificationBellStatePushMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncNotificationBellStatePushMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncNotificationBellStatePushMutation, { data, loading, error }] = useSyncNotificationBellStatePushMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSyncNotificationBellStatePushMutation(baseOptions?: Apollo.MutationHookOptions<SyncNotificationBellStatePushMutation, SyncNotificationBellStatePushMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SyncNotificationBellStatePushMutation, SyncNotificationBellStatePushMutationVariables>(SyncNotificationBellStatePushDocument, options);
      }
export type SyncNotificationBellStatePushMutationHookResult = ReturnType<typeof useSyncNotificationBellStatePushMutation>;
export type SyncNotificationBellStatePushMutationResult = Apollo.MutationResult<SyncNotificationBellStatePushMutation>;
export type SyncNotificationBellStatePushMutationOptions = Apollo.BaseMutationOptions<SyncNotificationBellStatePushMutation, SyncNotificationBellStatePushMutationVariables>;